/* product.js — PDP image gallery + variant selection */

(function () {
  'use strict';

  // Image gallery thumbnails
  var thumbs = document.querySelectorAll('.pdp__thumb');
  var slides = document.querySelectorAll('.pdp__image-slide');

  thumbs.forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      var index = this.dataset.index;
      thumbs.forEach(function (t) { t.classList.remove('is-active'); });
      slides.forEach(function (s) { s.classList.remove('is-active'); });
      this.classList.add('is-active');
      var target = document.querySelector('.pdp__image-slide[data-index="' + index + '"]');
      if (target) target.classList.add('is-active');
    });
  });

  // Variant selection
  var productJson = document.getElementById('product-json');
  if (!productJson) return;

  var product = JSON.parse(productJson.textContent);
  var form = document.getElementById('product-form');
  if (!form) return;

  var variantIdInput = document.getElementById('variant-id');
  var addButton = form.querySelector('.pdp__add');

  form.addEventListener('change', function () {
    var selectedOptions = [];
    form.querySelectorAll('fieldset.pdp__option').forEach(function (fieldset) {
      var checked = fieldset.querySelector('input:checked');
      if (checked) selectedOptions.push(checked.value);
    });

    // Update active pill styles
    form.querySelectorAll('.pdp__size-pill').forEach(function (pill) {
      var input = pill.querySelector('input');
      pill.classList.toggle('is-active', input.checked);
    });

    // Find matching variant
    var matchedVariant = product.variants.find(function (v) {
      return v.options.every(function (opt, i) {
        return opt === selectedOptions[i];
      });
    });

    if (matchedVariant) {
      variantIdInput.value = matchedVariant.id;
      if (matchedVariant.available) {
        addButton.disabled = false;
        addButton.innerHTML = 'Add to Cart &mdash; ' + formatMoney(matchedVariant.price);
      } else {
        addButton.disabled = true;
        addButton.textContent = 'Sold Out';
      }
    }
  });

  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }
})();
